import { RenderElementProps, useFocused, useSelected } from 'slate-react';
import { useTheme } from '@mui/material/styles';
import { ImageElement } from '../../types';

// Image element, including Slate's children prop requirement
type ImageProps = Omit<RenderElementProps, 'element'> & {
	element: ImageElement;
};
export const Image = ({ element, attributes, children }: ImageProps) => {
	const selected = useSelected();
	const focused = useSelected();
	const theme = useTheme();

	const style = {
		boxShadow: selected && focused ? `0 0 0 3px ${theme.palette.info.main}` : 'none',
		maxWidth: '100%',
	};
	return (
		<div {...attributes}>
			<img src={element.src} style={style} />
			{/* Children must be rendered, even in void elements */}
			{children}
		</div>
	);
};
